var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M18,15h2v2H0V15H2V8A8,8,0,1,1,18,8Zm-2,0V8A6,6,0,0,0,4,8v7ZM7,19h6v2H7Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }